/**
 * @generated SignedSource<<48eefd79bc9aa1332709f159314983aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type LoginScreen_AuthenticateMutation$variables = {
  email: string;
  password: string;
};
export type LoginScreen_AuthenticateMutation$data = {
  readonly authenticate: {
    readonly secureToken: string | null | undefined;
  };
};
export type LoginScreen_AuthenticateMutation = {
  response: LoginScreen_AuthenticateMutation$data;
  variables: LoginScreen_AuthenticateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "email"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "password"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
          },
          {
            "kind": "Variable",
            "name": "password",
            "variableName": "password"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AuthenticatePayload",
    "kind": "LinkedField",
    "name": "authenticate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "secureToken",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginScreen_AuthenticateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginScreen_AuthenticateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4de4eabb490f3c8b1573241c9ed5fbce",
    "id": null,
    "metadata": {},
    "name": "LoginScreen_AuthenticateMutation",
    "operationKind": "mutation",
    "text": "mutation LoginScreen_AuthenticateMutation(\n  $email: String!\n  $password: String!\n) {\n  authenticate(input: {email: $email, password: $password}) {\n    secureToken\n  }\n}\n"
  }
};
})();

(node as any).hash = "f59fc605099fe656c50f2cd18ec31435";

export default node;
